<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{ data.title }}</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <form [formGroup]="scheduleGroup">
            <input matInput [formControlName]="'id'" hidden>
            <input matInput [formControlName]="'scheduleId'" hidden>
            <div class="row">
                <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                    <mat-label>Day of Week</mat-label>
                    <mat-select formControlName="weekDay" required>
                        <mat-option *ngFor="let day of weekdays" [value]="day.value">{{
                            day.name }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="col-lg-4 col-md-4 col-sm-12 checkbox-container">
                    <mat-checkbox formControlName="isRestDay">Rest Day</mat-checkbox>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-lg-4 col-md-4 col-sm-6 order-1">
                    <div class="form-group row">
                        <mat-form-field class="example-full-width col-12" appearance="outline">
                            <mat-label>First Time In</mat-label>
                            <mat-icon class="icon" (click)="timepicker1.open()">access_time</mat-icon>
                            <input matInput [ngxTimepicker]="timepicker1" formControlName="rampTime1"
                                placeholder="First Time In" required>
                            <ngx-material-timepicker #timepicker1></ngx-material-timepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 order-2">
                    <div class="form-group row">
                        <mat-form-field class="example-full-width col-12" appearance="outline">
                            <mat-label>First Time Out</mat-label>
                            <mat-icon class="icon" (click)="timepicker2.open()">access_time</mat-icon>
                            <input matInput [ngxTimepicker]="timepicker2" formControlName="rampTime2"
                                placeholder="First Time Out" required>
                            <ngx-material-timepicker #timepicker2></ngx-material-timepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 order-3">
                    <div class="form-group row">
                        <mat-form-field class="example-full-width col-12" appearance="outline">
                            <mat-label>Second Time In</mat-label>
                            <mat-icon class="icon" (click)="timepicker3.open()">access_time</mat-icon>
                            <input matInput [ngxTimepicker]="timepicker3" formControlName="rampTime3"
                                placeholder="Second Time In" required>
                            <ngx-material-timepicker #timepicker3></ngx-material-timepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 order-4">
                    <div class="form-group row">
                        <mat-form-field class="example-full-width col-12" appearance="outline">
                            <mat-label>Second Time Out</mat-label>
                            <mat-icon class="icon" (click)="timepicker4.open()">access_time</mat-icon>
                            <input matInput [ngxTimepicker]="timepicker4" formControlName="rampTime4"
                                placeholder="Second Time Out" required>
                            <ngx-material-timepicker #timepicker4></ngx-material-timepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 order-5">
                    <div class="form-group row">
                        <mat-form-field class="example-full-width col-12" appearance="outline">
                            <mat-label>OT Time In</mat-label>
                            <mat-icon class="icon" (click)="timepicker5.open()">access_time</mat-icon>
                            <input matInput [ngxTimepicker]="timepicker5" formControlName="rampTime5"
                                placeholder="OT Time In" required>
                            <ngx-material-timepicker #timepicker5></ngx-material-timepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 order-6">
                    <div class="form-group row">
                        <mat-form-field class="example-full-width col-12" appearance="outline">
                            <mat-label>OT Time Out</mat-label>
                            <mat-icon class="icon" (click)="timepicker6.open()">access_time</mat-icon>
                            <input matInput [ngxTimepicker]="timepicker6" formControlName="rampTime6"
                                placeholder="OT Time Out" required>
                            <ngx-material-timepicker #timepicker6></ngx-material-timepicker>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12 checkbox-container">
                    <mat-checkbox formControlName="RAMP_isAddMissingTime">Use Default Schedule for Missing
                        Time</mat-checkbox>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 checkbox-container">
                    <mat-checkbox formControlName="RAMP_isComputeRestDay">Compute Rest Day</mat-checkbox>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 checkbox-container">
                    <mat-checkbox formControlName="RAMP_isComputeHoliday">is Compute Holiday</mat-checkbox>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12 checkbox-container">
                    <mat-checkbox formControlName="RAMP_isAdjustOT">Adjust to Allowable OT</mat-checkbox>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 checkbox-container">
                    <mat-checkbox formControlName="RAMP_isComputeNightDiff">Compute Night Differential</mat-checkbox>
                </div>
            </div>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <button mat-button class="btn btn-success yes-button" [disabled]="scheduleGroup.invalid" (click)="save()"
            *ngIf="!isLoading; else loadingTemplate" cdkFocusInitial>{{data.confirmText}}</button>
        <ng-template #loadingTemplate>
            <button mat-button class="btn btn-success yes-button" cdkFocusInitial disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>